import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const chatFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.5234 20.7767C37.249 20.4956 36.8696 20.3185 36.4575 20.3185H35.2588C34.4335 20.3185 33.7571 20.9975 33.7571 21.8307V27.7068C33.7571 28.5425 34.4335 29.2189 35.2588 29.2189H36.4575C36.8968 29.2189 37.2927 29.0285 37.5675 28.7249C37.8392 29.0289 38.2308 29.22 38.666 29.22H43.3533C44.1812 29.22 44.857 28.5416 44.857 27.708C44.857 27.5307 44.8223 27.3547 44.7582 27.188C45.3511 26.9861 45.7811 26.4199 45.7811 25.7549C45.7811 25.573 45.7437 25.3898 45.6769 25.2167C46.2672 25.014 46.7052 24.4478 46.7052 23.8014C46.7052 23.6147 46.6705 23.4323 46.6064 23.2641C47.1886 23.0584 47.6106 22.4949 47.6106 21.8325C47.6106 21.0126 46.9322 20.3181 46.1283 20.3181H40.9896C41.887 18.4352 42.1007 17.009 41.6226 16.0742C41.2994 15.4385 40.7225 15.1982 40.4341 15.1554C40.2551 15.1341 40.0949 15.2195 40.0228 15.3771L37.5234 20.7767ZM37.9983 21.5921C37.9983 21.5992 37.9959 21.6064 37.9935 21.6135C37.9923 21.617 37.9911 21.6206 37.9903 21.6242C37.9741 21.6771 37.962 21.7421 37.9589 21.8035C37.9591 21.8125 37.9592 21.8216 37.9592 21.8307V27.7068C37.9592 27.7177 37.9591 27.7286 37.9588 27.7395C37.9748 28.1296 38.2862 28.4425 38.666 28.4425H43.3533C43.7539 28.4425 44.0771 28.1127 44.0771 27.708C44.0771 27.5115 43.9863 27.3128 43.8234 27.1624C43.7085 27.0534 43.6685 26.8844 43.7299 26.7359C43.786 26.5868 43.9302 26.4896 44.0904 26.4896H44.2774C44.67 26.4896 45.0012 26.1528 45.0012 25.7549C45.0012 25.5535 44.9051 25.3374 44.7501 25.1927C44.6326 25.084 44.5926 24.9144 44.6513 24.7659C44.7101 24.6168 44.8543 24.5191 45.0145 24.5191H45.2015C45.5888 24.5191 45.9253 24.1839 45.9253 23.8014C45.9253 23.5175 45.7677 23.3281 45.6742 23.24C45.5567 23.1305 45.5167 22.9622 45.5754 22.8127C45.6342 22.6631 45.7784 22.567 45.9387 22.567H46.1283C46.5156 22.567 46.8334 22.2358 46.8334 21.8325C46.8334 21.4399 46.5022 21.0953 46.1283 21.0953H40.3593C40.2231 21.0953 40.0975 21.0259 40.0281 20.9084C39.956 20.7935 39.9533 20.6466 40.0147 20.5265C41.3395 17.9945 41.1579 16.8728 40.9309 16.4267C40.8294 16.2291 40.6931 16.1062 40.5756 16.0341L38.0944 21.3891C38.025 21.512 38.0063 21.5627 38.0036 21.5761C38.0023 21.5788 38.0016 21.5814 38.0009 21.5841C38.0003 21.5868 37.9996 21.5895 37.9983 21.5921ZM34.538 21.8307C34.538 21.4337 34.867 21.0968 35.2588 21.0968H36.4575C36.844 21.0968 37.1809 21.4389 37.1809 21.8307V27.7068C37.1809 28.1064 36.8493 28.4433 36.4575 28.4433H35.2588C34.8618 28.4433 34.538 28.1116 34.538 27.7068V21.8307Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.6811 35.2372C31.8377 35.2823 32.3912 35.4248 33.1445 35.4248C34.7078 35.4248 37.1325 34.8125 38.6634 31.4493H46.8444C49.8928 31.4493 52.3687 28.9413 52.3687 25.8584V18.4957C52.3687 15.4204 49.8928 12.9202 46.8444 12.9202H34.5242C31.4786 12.9202 29 15.4204 29 18.4957V25.8584C29 28.4426 30.8009 30.7055 33.2525 31.2922C32.9231 32.3598 32.3183 33.1949 31.457 33.7754C31.0898 34.0111 30.9818 34.5068 31.2221 34.8867C31.322 35.0409 31.4597 35.1511 31.6811 35.2372ZM29.7803 18.4957C29.7803 15.8497 31.9079 13.6978 34.5242 13.6978H46.8444C49.4635 13.6978 51.5911 15.8497 51.5911 18.4957V25.8584C51.5911 28.5123 49.4635 30.672 46.8444 30.672H38.4096C38.253 30.672 38.1126 30.7646 38.0505 30.908C36.1146 35.4508 32.5829 34.6875 31.8836 34.4256C33.023 33.6582 33.7736 32.5331 34.1165 31.0805C34.1408 30.9749 34.1192 30.8643 34.0598 30.7743C34.0004 30.6844 33.9032 30.6239 33.7979 30.6072C31.5056 30.2513 29.7803 28.2099 29.7803 25.8584V18.4957Z"
        fill={frameColor}
      />
      <path
        d="M62.8544 42.1788C61.2754 42.1791 58.8622 41.5597 57.339 38.2078H49.1566C46.1101 38.2078 43.6328 35.6995 43.6328 32.6168C43.6328 32.4017 43.8057 32.2279 44.0205 32.2279C44.2381 32.2279 44.4111 32.4017 44.4111 32.6168C44.4111 35.2707 46.5397 37.43 49.1566 37.43H57.5928C57.7491 37.43 57.8886 37.5229 57.9499 37.6663C59.886 42.2092 63.4179 41.4465 64.1042 41.2487C62.9771 40.4162 62.2267 39.2905 61.8863 37.8387C61.8612 37.7332 61.8807 37.622 61.9421 37.5321C62.0007 37.4426 62.0983 37.3817 62.2043 37.3656C64.4948 37.0124 66.2216 34.9708 66.2216 32.6168V25.2537C66.2216 22.609 64.093 20.4572 61.4762 20.4572H53.2296C53.0148 20.4572 52.8391 20.2834 52.8391 20.0683C52.8391 19.8535 53.0148 19.6797 53.2296 19.6797H61.4762C64.5227 19.6797 67 22.1802 67 25.2537V32.6168C67 35.2038 65.2006 37.466 62.7484 38.051C63.0775 39.1178 63.6829 39.9536 64.5506 40.5387C64.9105 40.7683 65.0193 41.2643 64.7821 41.6387C64.6789 41.7982 64.5422 41.9084 64.3609 41.9815C64.1907 42.032 63.6216 42.1788 62.8544 42.1788Z"
        fill={frameColor}
      />
      <path
        d="M55.3154 34.8374C55.2244 34.8374 55.1306 34.8045 55.0561 34.7391C53.6107 33.4512 52.1183 32.1194 50.968 30.7981C50.8246 30.6364 50.8439 30.3904 51.0039 30.2494C51.1694 30.1082 51.4121 30.1258 51.5528 30.2872C52.6038 31.4941 53.9693 32.7279 55.3182 33.9279C58.2146 31.3553 61.122 28.7036 61.122 26.1873C61.122 24.8767 59.9055 23.8105 58.4132 23.8105C57.1332 23.8105 56.4353 24.2834 55.6547 25.6849C55.5857 25.8085 55.4561 25.8847 55.3154 25.8847C55.172 25.8844 55.0423 25.8066 54.9734 25.6827C54.4493 24.7247 53.9527 24.2144 53.3155 23.9761C53.1141 23.9007 53.0121 23.6768 53.0865 23.4757C53.161 23.2746 53.3872 23.173 53.5858 23.2475C54.2644 23.5005 54.8023 23.9595 55.3182 24.7402C56.0188 23.6726 56.8629 23.0329 58.4132 23.0329C60.3359 23.0329 61.8999 24.4478 61.8999 26.1873C61.8999 29.1267 58.6872 31.9777 55.58 34.735L55.5747 34.7397C55.5002 34.8051 55.4092 34.8374 55.3154 34.8374Z"
        fill={frameColor}
      />
      <rect
        x="23"
        y="46"
        width="50"
        height="50"
        rx="2"
        fill={frameBackgroundColor}
      />

      <foreignObject
        width="46%"
        height="44px"
        style={{ borderRadius: "3px" }}
        x="26"
        y="49">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="95">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
